import styled, { css } from 'styled-components';

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  cursor: pointer;

  ${({ theme }) => css`
    right: ${theme.sizes[2]}px;
  `};
  transform: translateY(-50%);
`;
